import { CircularProgress, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useParams } from 'react-router';
import Carousel from 'nuka-carousel';
import Page from '../components/Page';
import Image from '../components/Image';
import { useQuery } from 'react-query';

import { loaderStyle } from 'src/utils/styles';
import DoctorReview from 'src/components/DoctorRequestPage/DoctorReview';
import { images } from 'src/utils/constants';
import RequestHeader from 'src/components/admin/Request/RequestHeader';
import { getRequestById } from 'src/services/request.service';

const DoctorRequestPage = ({ reqId, preview = false }) => {
  const { id } = useParams();
  // const [remaining, setRemaining] = useState(0);
  const divRef = React.useRef();

  const {
    isLoading: loading,
    data: request,
    isError
  } = useQuery(['request', preview ? reqId : id], async () => {
    return await getRequestById({ id: preview ? reqId : id });
  });

  // data of the request owner
  if (loading) {
    return <CircularProgress style={loaderStyle} />;
  }
  if (isError) return <ErrorPage />;
  return (
    <Page title={'Doctor Requests | Incorta Care'}>
      <Grid container direction="column" spacing={0} style={{ padding: '12px' }}>
        <RequestHeader
          data={{ request: request?.data }}
          showBalance={false}
          showHistory={!preview}
        />

        {Object.entries(images).map((arr) => {
          return (
            <Grid
              key={arr[0]}
              direction="column"
              style={{
                marginTop: '20px'
              }}
            >
              <Typography variant="h4">{arr[1]}</Typography>
              {request?.data[arr[0]].length === 0 ? (
                <Typography>NA </Typography>
              ) : (
                <Carousel height="60vh">
                  {request?.data[arr[0]].map((imgKey) => {
                    return <Image key={imgKey} imgKey={imgKey} />;
                  })}
                </Carousel>
              )}
            </Grid>
          );
        })}
        <Grid
          direction="column"
          style={{
            marginTop: '20px',
            overflow: 'hidden',
            borderRadius: '10px',
            padding: '10px',
            boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)'
          }}
        >
          <Typography variant="h4">Employee Notes</Typography>
          <Typography variant="body1" gutterBottom>
            {request?.data?.notes ?? 'NA'}
          </Typography>
        </Grid>
        {request?.data?.status == 'PENDING_DR_REVIEW' && !preview ? (
          <DoctorReview id={id} originalComments={request?.data?.dr_comments} />
        ) : null}
        <div ref={divRef} style={{ visibility: 'hidden', height: '1px' }}>
          Just to scroll
        </div>
      </Grid>
    </Page>
  );
};

export default DoctorRequestPage;
